<template>
  <transition name="bounce">
    <b-container class="py-5 custom-container container">
      <h2 class="pl-0 pt-5 mt-5 font-weight-bold">
        File Upload
      </h2>
      <h3 class="pl-0 mt-5 font-weight-bold">
        Template Section
      </h3>
      <p class="pl-0 text-secondary">
        Select from the types of file you want to upload below or upload a new
        document
      </p>
      <b-row class="ml-auto">
        <b-col :md="3" :cols="6">
          <b-card class="first" @click="newFilePage">
            <b-img-lazy
              center
              :src="require('@/assets/icons/add.png')"
            ></b-img-lazy>
            <b-card-body class="text-center">
              <b-card-title class="font-weight-bold">New Upload</b-card-title>

              <b-card-text class="text-secondary">
                Create without a template
              </b-card-text>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col
          :md="3"
          :cols="6"
          class="mb-4"
          v-for="template in templates"
          :key="template.id"
        >
          <template-item
            :template="template"
            @click="templateForm(template.id)"
          />
        </b-col>
      </b-row>
    </b-container>
  </transition>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import TemplateItem from './TemplateItem'

export default {
  components: {
    TemplateItem
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters('template', ['templates']),
    ...mapGetters('requests', ['request']),

    isRequestFileCreation() {
      return this.$route.name === 'request.request-file-templates-page'
    }
  },
  methods: {
    ...mapActions('template', ['getTemplates']),
    ...mapActions('requests', ['getRequestByUser']),
    async fetchTemplates() {
      this.loading = true
      await this.getTemplates()
      this.loading = false
    },
    newFilePage() {
      if (this.isRequestFileCreation) {
        this.$router.replace({
          name: 'request.request-file-new-page',
          params: {
            fileRequestUserId: this.$route.params.fileRequestUserId
          }
        })
      } else {
        this.$router.replace({ name: 'file.new-page' })
      }
    },
    templateForm(template) {
      if (this.isRequestFileCreation) {
        this.$router.replace({
          name: 'request.request-file-template-form-page',
          params: {
            fileRequestUserId: this.$route.params.fileRequestUserId,
            id: template
          }
        })
      } else {
        this.$router.replace({
          name: 'template.form-page',
          params: {
            id: template
          }
        })
      }
    }
  },
  async mounted() {
    // this.fetchTemplates()
    if (this.isRequestFileCreation) {
      await this.getRequestByUser(this.$route.params.fileRequestUserId)
        .then(async () => {
          await this.fetchTemplates().then(() => {
            if (this.request.file_request.template) {
              this.templateForm(this.request.file_request.template.id)
            }
          })
        })
        .catch(err => {
          if (err.data && err.data.status === 404) {
            this.$router.replace({ name: 'page-not-found' })
          }
        })
    } else {
      await this.fetchTemplates()
    }
  }
}
</script>
<style lang="scss" scoped>
.card {
  width: 342px;
  height: 342px;
  cursor: pointer;

  &:hover {
    background: #eaf3ff 0% 0% no-repeat padding-box;
    box-shadow: 0px 10px 25px #00429d0d;
  }

  @media (max-width: 767px) {
    width: 173px;
    height: 175px;

    img {
      width: 74px;
      height: 74px;
    }

    .card-body {
      padding-top: 0.5rem;
      padding-left: 0.25rem;
      padding-right: 0.25rem;
      padding-bottom: 0.5rem;
    }

    .card-title {
      font-size: 1rem;
    }

    .card-text:last-child {
      font-size: 0.9rem;
      line-height: 15px;
    }
  }
}
.first {
  background: #ebedf095;
}
</style>
